setTimeout(() => {
    if (window.innerWidth < 720 ) {
        let dropdownMenuTitle = document.querySelectorAll(".pxu-tabs label.tab-label");

        dropdownMenuTitle.forEach((title, index) => {
            if (index !== 0) {
                title.nextElementSibling.style.height = 0 + "px";
                title.nextElementSibling.style.paddingBottom = 0 + "px";
                title.nextElementSibling.style.paddingTop = 0 + "px";
            } else {
                title.classList.add("active");
            }
            title.addEventListener("click", ()=>{
                if (title.classList.contains("active")) {
                    title.classList.remove("active");
                    title.nextElementSibling.style.height = 0 + "px";
                    title.nextElementSibling.style.paddingBottom = 0 + "px";
                    title.nextElementSibling.style.paddingTop = 0 + "px";
                } else {
                    if (document.querySelector(".pxu-tabs label.tab-label.active")) {
                        dropdownMenuTitle.forEach(title => {
                            title.classList.remove("active");
                            title.nextElementSibling.style.height = 0 + "px";
                            title.nextElementSibling.style.paddingBottom = 0 + "px";
                            title.nextElementSibling.style.paddingTop = 0 + "px";
                        });
                    }
                    title.classList.add("active");
                    title.nextElementSibling.style.height = title.nextElementSibling.scrollHeight + 40 + "px";
                    title.nextElementSibling.style.paddingTop = "1.35rem";

                    setTimeout(() => {
                        title.scrollIntoView({
                            behavior: 'auto',
                            block: 'start',
                            inline: 'center'
                        });
                    }, 110);
                }
            })
        });
    }
}, 1);



// Make product rating clickable and scroll to reviews
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Judge.me to load
  setTimeout(function() {
    // Target the rating container directly using the class structure
    const ratingElement = document.querySelector('.product__rating.rating, .product__rating, [class*="product__rating"]');
    
    // Fallback: Find by the review count text
    if (!ratingElement) {
      const allElements = document.querySelectorAll('*');
      
      for (let el of allElements) {
        const text = el.textContent.trim();
        // Look for "X Reviews" or "X Review" text
        if ((text.match(/^\d+\s+Reviews?$/i)) && 
            el.offsetHeight > 0 && 
            el.offsetHeight < 100) {
          // Make sure it's near the top (not deep in the reviews section)
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.top < 1000) {
            // Found the review count, get the .product__rating parent
            let parent = el.closest('.product__rating, .rating, [class*="rating"]');
            if (parent) {
              ratingElement = parent;
              break;
            }
          }
        }
      }
    }
    
    if (ratingElement) {
      // Make it clickable
      ratingElement.style.cursor = 'pointer';
      ratingElement.style.transition = 'opacity 0.2s';
      
      // Add hover effect
      ratingElement.addEventListener('mouseenter', function() {
        this.style.opacity = '0.7';
      });
      
      ratingElement.addEventListener('mouseleave', function() {
        this.style.opacity = '1';
      });
      
      // Add click event to scroll to reviews
      ratingElement.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the main reviews widget
        const reviewsSection = document.querySelector(
          '#judgeme_product_reviews, ' +
          '.jdgm-widget.jdgm-review-widget, ' +
          '.jdgm-review-widget'
        );
        
        if (reviewsSection) {
          // Get header height for offset
          const header = document.querySelector('header, .site-header, [data-header]');
          const headerHeight = header ? header.offsetHeight : 0;
          
          // Calculate position
          const elementPosition = reviewsSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 20;
          
          // Smooth scroll
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  }, 2000);
});

// Init Flickity Slider
const initFlickity = (root = document) => {
  if (!window.Flickity) {
    return;
  }

  const sliders = [];
  if (root.matches && root.matches('[data-aw-flickity]')) {
    sliders.push(root);
  }
  if (root.querySelectorAll) {
    sliders.push(...root.querySelectorAll('[data-aw-flickity]'));
  }

  sliders.forEach(slider => {
    if (slider.hasAttribute('data-aw-flickity-ready')) return;

    let options = {};
    try {
      options = JSON.parse(slider.dataset.awFlickity || slider.dataset.flickity || '{}');
    } catch (error) {
      console.warn('Unable to parse Atomic Wheels slider options', slider, error);
    }

    slider.setAttribute('data-aw-flickity-ready', 'true');
    slider.awFlickity = new Flickity(slider, options);
  });
}

const observeDynamicFlickity = () => {
  if (!document.body || window.__awDynamicFlickityObserver) return;

  window.__awDynamicFlickityObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) initFlickity(node);
      });
    });
  });

  window.__awDynamicFlickityObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// "Sticky section navigation" handle
const initStickySectionNav = () => {
  const nav = document.querySelector('.js-sticky-section-navigation');
  if (!nav) return;
  
  const items = nav.querySelectorAll('[data-target]');
  const sections = [];
  
  items.forEach(item => {
    let target = document.getElementById(item.dataset.target);
    // Fallback: when a template gets duplicated in Shopify, its section IDs
    // get a new template-id prefix but the sticky-nav's saved target_id can
    // stay pointing to the old one. Match by the trailing `__<section_name>`
    // suffix so the nav survives template re-IDing.
    if (!target) {
      const suffix = (item.dataset.target || '').match(/__[A-Za-z0-9_]+$/);
      if (suffix) {
        target = document.querySelector(`[id^="shopify-section-template--"][id$="${suffix[0]}"]`);
      }
    }
    if (!target || !target.children.length) {
      item.style.display = 'none'; // hide broken item
      return;
    }

    sections.push({ item, target });
  
    item.addEventListener('click', () => {
      const rect = target.getBoundingClientRect();
      const targetSpacing = parseInt(window.getComputedStyle(target).marginTop) || 0;
      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;
      const stickyBarHeight = item.closest('.js-sticky-section-navigation').offsetHeight;

      const absoluteTop = rect.top + window.pageYOffset - targetSpacing - headerHeight - stickyBarHeight;

      window.scrollTo({
        top: absoluteTop,
        behavior: 'smooth',
      });

      items.forEach(elem => elem.classList.remove('current'));
      item.classList.add('current');
    });
  });
  
  // Active state
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const active = entry.isIntersecting;
          sections.forEach(s => {
            if (s.target === entry.target) {
              s.item.classList.toggle('current', active);
            }
          });
        });
      },
      { 
        rootMargin: '-30% 0px -60% 0px',
        threshold: 0
      }
    );
    
    sections.forEach(s => observer.observe(s.target));
  }
}

const initVariantSelection = () => {
  let $variant_selection = document.querySelector('.variant-selection');
  if (!$variant_selection) return;

  let $sections = Array.from(document.querySelectorAll('.section-variants'));

  const updateSections = () => {
    let variant = document.querySelector('.variant-selection').getAttribute('variant');  

    $sections.forEach(group => {
      const sections = group.querySelectorAll('.section-variants__variant');

      let matchedSection = null;
      let defaultSection = null;
      
      Array.from(sections).forEach(section => {
        const id = section.getAttribute('data-variant-id');
        section.style.display = 'none';

        if (id == variant) matchedSection = section;
        if (id == 'default') defaultSection = section;
      });

      if (matchedSection) {
        matchedSection.style.display = 'initial';
      } else if (defaultSection) {
        defaultSection.style.display = 'initial';
      }
    });
  };

  updateSections();

  $variant_selection.addEventListener('change', (e) => {
    setTimeout(updateSections, 1000);
  });
}


document.addEventListener("DOMContentLoaded", (event) => {
  initStickySectionNav();
});

window.onload = function() {
  initFlickity();
  observeDynamicFlickity();
  initVariantSelection();
};

/* Keep ProductWiz/Rio's visible option picker aligned with Empire's native
 * variant selection. The option the customer clicks is authoritative; when
 * that combination does not exist, choose a real variant and align every
 * option so the image, price, availability, URL, and cart variant agree. */
(function() {
  if (window.__awRioVariantSync || !/^\/products\//.test(location.pathname)) return;
  window.__awRioVariantSync = true;

  var syncing = false;
  var adjustmentTimer = null;

  function installAdjustmentStyles() {
    if (document.getElementById('aw-variant-adjustment-styles')) return;
    var style = document.createElement('style');
    style.id = 'aw-variant-adjustment-styles';
    style.textContent = [
      '.aw-variant-auto-adjusted {',
      '  --aw-adjust-ring: #008bd2;',
      '  --aw-adjust-halo: rgba(0, 139, 210, .38);',
      '  position: relative;',
      '  z-index: 2;',
      '  border-color: var(--aw-adjust-ring) !important;',
      '  box-shadow: 0 0 0 3px #fff, 0 0 0 7px var(--aw-adjust-halo) !important;',
      '  animation: awVariantAutoAdjusted 4.2s ease-out 1;',
      '}',
      '@keyframes awVariantAutoAdjusted {',
      '  0% { box-shadow: 0 0 0 3px #fff, 0 0 0 10px rgba(0, 139, 210, .58); }',
      '  16%, 88% { box-shadow: 0 0 0 3px #fff, 0 0 0 7px var(--aw-adjust-halo); }',
      '  100% { box-shadow: 0 0 0 3px #fff, 0 0 0 5px rgba(0, 139, 210, .16); }',
      '}',
      '.aw-color-focus [data-option-value] {',
      '  opacity: .58;',
      '  filter: brightness(.78) saturate(.72);',
      '  transition: opacity .18s ease, filter .18s ease, border-color .18s ease, box-shadow .18s ease;',
      '}',
      '.aw-color-focus [data-option-value].aw-color-current {',
      '  opacity: 1;',
      '  filter: none;',
      '  border-color: var(--aw-adjust-ring, #008bd2) !important;',
      '  box-shadow: 0 0 0 3px #fff, 0 0 0 7px rgba(0, 139, 210, .38) !important;',
      '}',
      '.aw-color-focus [data-option-value]:not(.aw-color-current):hover,',
      '.aw-color-focus [data-option-value]:not(.aw-color-current):focus-visible {',
      '  opacity: .82;',
      '  filter: brightness(.92) saturate(.9);',
      '}',
      '@media (prefers-reduced-motion: reduce) {',
      '  .aw-variant-auto-adjusted { animation: none; }',
      '  .aw-color-focus [data-option-value] { transition: none; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function clearAdjustment() {
    if (adjustmentTimer) {
      clearTimeout(adjustmentTimer);
      adjustmentTimer = null;
    }
    document.querySelectorAll('.aw-variant-adjustment-notice').forEach(function(notice) {
      notice.remove();
    });
    document.querySelectorAll('.aw-variant-auto-adjusted').forEach(function(button) {
      button.classList.remove('aw-variant-auto-adjusted');
    });
    document.querySelectorAll('.aw-color-current').forEach(function(button) {
      button.classList.remove('aw-color-current');
    });
    document.querySelectorAll('.aw-color-focus').forEach(function(group) {
      group.classList.remove('aw-color-focus');
    });
  }

  function rioGroups() {
    return Array.from(document.querySelectorAll('[data-option][data-option-type]'));
  }

  function productData() {
    return window.__productWizRioProduct || null;
  }

  var productDataPromise = null;
  function loadProductData() {
    var existing = productData();
    if (existing) return Promise.resolve(existing);
    if (productDataPromise) return productDataPromise;
    var match = location.pathname.match(/^\/products\/([^/?#]+)/);
    if (!match) return Promise.reject(new Error('Product handle is unavailable'));
    productDataPromise = fetch('/products/' + encodeURIComponent(match[1]) + '.js', {
      credentials: 'same-origin'
    }).then(function(response) {
      if (!response.ok) throw new Error('Product JSON request failed');
      return response.json();
    }).then(function(product) {
      window.__productWizRioProduct = product;
      return product;
    });
    return productDataPromise;
  }

  function optionNames() {
    var product = productData();
    if (product && Array.isArray(product.options)) {
      return product.options.map(function(option) { return option.name; });
    }
    return rioGroups().map(function(group) { return group.getAttribute('data-option'); });
  }

  function nativeValue(optionName) {
    var inputs = document.querySelectorAll('.options-selection__option-value-input:checked');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].name === optionName) return inputs[i].value;
    }
    return '';
  }

  function visibleValue(group, optionName) {
    var block = group.parentElement && group.parentElement.parentElement;
    var title = block && block.querySelector('.rio-product-option-title');
    if (!title) return '';
    var prefix = optionName + ':';
    var text = title.textContent.trim();
    return text.indexOf(prefix) === 0 ? text.slice(prefix.length).trim() : '';
  }

  function findGroup(optionName) {
    return rioGroups().find(function(group) {
      return group.getAttribute('data-option') === optionName;
    });
  }

  function findButton(group, value) {
    var buttons = group.querySelectorAll('[data-option-value]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-option-value') === value) return buttons[i];
    }
    return null;
  }

  function compatibleVariant(sourceName, sourceValue, currentValues) {
    var product = productData();
    if (!product || !Array.isArray(product.variants)) return null;

    var names = optionNames();
    var sourceIndex = names.indexOf(sourceName);
    if (sourceIndex < 0) return null;

    var candidates = product.variants.filter(function(variant) {
      return Array.isArray(variant.options) && variant.options[sourceIndex] === sourceValue;
    });
    if (!candidates.length) return null;

    var available = candidates.filter(function(variant) { return variant.available !== false; });
    if (available.length) candidates = available;

    /* Preserve earlier choices by Shopify option priority. Later choices keep
     * Shopify's existing first-available behavior. */
    for (var i = 0; i < sourceIndex; i++) {
      var matching = candidates.filter(function(variant) {
        return variant.options[i] === currentValues[i];
      });
      if (matching.length) candidates = matching;
    }

    return { names: names, variant: candidates[0] };
  }

  function clickOption(optionName, value) {
    var group = findGroup(optionName);
    if (!group) return;
    if (nativeValue(optionName) === value && visibleValue(group, optionName) === value) return;

    var button = findButton(group, value);
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    button.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));
  }

  function selectionMatches(names, variant) {
    for (var i = 0; i < names.length; i++) {
      if (nativeValue(names[i]) !== variant.options[i]) return false;
    }
    var select = document.querySelector('variant-selection select[name="id"], variant-selection select');
    return !select || String(select.value) === String(variant.id);
  }

  function showAdjustment(sourceName, names, variant, previousValues) {
    var sourceIndex = names.indexOf(sourceName);
    var changed = names.map(function(name, index) {
      return { name: name, index: index, value: variant.options[index] };
    }).filter(function(option) {
      return option.index !== sourceIndex && previousValues[option.index] !== option.value;
    });
    var colorIndex = names.indexOf('Color');
    var colorChanged = changed.some(function(option) { return option.name === 'Color'; });
    var focusColor = colorIndex >= 0 && (sourceName === 'Color' || colorChanged);
    if (!changed.length && !focusColor) return;

    installAdjustmentStyles();
    changed.forEach(function(option) {
      var group = findGroup(option.name);
      var button = group && findButton(group, option.value);
      if (button) button.classList.add('aw-variant-auto-adjusted');
    });

    if (focusColor) {
      var colorGroup = findGroup('Color');
      var colorButton = colorGroup && findButton(colorGroup, variant.options[colorIndex]);
      if (colorGroup && colorButton) {
        colorGroup.classList.add('aw-color-focus');
        colorButton.classList.add('aw-color-current');
      }
    }

    adjustmentTimer = setTimeout(clearAdjustment, 4200);
  }

  function needsVariantReload(variant, matched, button, userInitiated) {
    if (!userInitiated || !variant || variant.available !== true) return false;
    if (button && button.getAttribute('aria-busy') === 'true') return false;
    return !matched || Boolean(button && button.disabled);
  }

  function syncVariant(names, variant, sourceName, previousValues, userInitiated) {
    syncing = true;
    var index = 0;
    var retries = 0;

    function step() {
      if (index >= names.length) {
        setTimeout(verify, 220);
        return;
      }
      var optionIndex = index++;
      clickOption(names[optionIndex], variant.options[optionIndex]);
      setTimeout(step, 120);
    }

    function verify() {
      var matched = selectionMatches(names, variant);
      if (matched || retries >= 2) {
        syncing = false;
        var button = document.querySelector('form[data-product-form] [data-product-atc], form[action*="/cart/add"] button[name="add"]');
        if (needsVariantReload(variant, matched, button, userInitiated)) {
          // ProductWiz may repaint the options but leave Empire's original
          // sold-out form disabled. Re-render the exact proven variant rather
          // than force-enable a stale form or submit the wrong merchandise.
          navigateToVariant({ variant: variant }, true);
          return;
        }
        if (matched) showAdjustment(sourceName, names, variant, previousValues);
        return;
      }
      retries++;
      index = 0;
      step();
    }

    step();
  }

  function syncProductWizGalleryColor(color) {
    var handle = location.pathname.split('/products/')[1];
    if (handle !== 'awzz-for-bmw-m5-g90-g99' && handle !== 'aws-for-bmw-m5-g90-g99') return;

    var colorName = String(color || '').toLowerCase();
    var thumbnail = Array.from(document.querySelectorAll('main img[alt]')).find(function(image) {
      var alt = String(image.alt || '').toLowerCase();
      var visible = image.offsetWidth > 0 && image.offsetHeight > 0;
      var isThumbnail = image.offsetWidth <= 220 && !image.closest('.pwzrswiper-slide');
      return visible && isThumbnail && alt.indexOf(colorName) !== -1 && alt.indexOf('forged wheel render') !== -1;
    });

    if (thumbnail) thumbnail.click();
  }

  function navigateToVariant(target, repairStaleForm) {
    if (!target || !target.variant || !target.variant.id) return false;
    var currentSelect = document.querySelector('variant-selection select[name="id"], variant-selection select');
    if (!repairStaleForm && currentSelect && String(currentSelect.value) === String(target.variant.id)) return false;
    var nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('variant', target.variant.id);
    window.location.assign(nextUrl.toString());
    return true;
  }

  /* ProductWiz can mark both sides of a valid option transition unavailable:
   * from G90 20\" the 21\" button is disabled because the current 20\" size
   * does not exist at 21\", while the matching 21\" Front/Rear sizes are also
   * disabled because 20\" is selected. When Shopify's own product JSON proves
   * that the requested value has a valid variant, navigate to that exact
   * variant instead of trapping the customer in the current combination. */
  document.addEventListener('click', function(event) {
    if (syncing || window.__awRioFallbackNavigating || !event.target.closest) return;
    var button = event.target.closest('[data-option-value]');
    var group = button && button.closest('[data-option][data-option-type]');
    if (!group || String(button.className).indexOf('rio-swatch-unavailable') === -1) return;

    var sourceName = group.getAttribute('data-option');
    var sourceValue = button.getAttribute('data-option-value');
    var names = optionNames();
    var currentValues = names.map(nativeValue);
    var sourceIndex = names.indexOf(sourceName);
    if (sourceIndex >= 0) currentValues[sourceIndex] = sourceValue;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.__awRioFallbackNavigating = true;
    function finishNavigation() {
      var target = compatibleVariant(sourceName, sourceValue, currentValues);
      if (!navigateToVariant(target)) window.__awRioFallbackNavigating = false;
    }
    if (productData()) {
      finishNavigation();
    } else {
      loadProductData().then(finishNavigation).catch(function(error) {
        window.__awRioFallbackNavigating = false;
        console.warn('AW variant fallback:', error);
      });
    }
  }, true);

  document.addEventListener('click', function(event) {
    if (syncing || !event.target.closest) return;
    var button = event.target.closest('[data-option-value]');
    var group = button && button.closest('[data-option][data-option-type]');
    if (!group) return;
    clearAdjustment();

    var sourceName = group.getAttribute('data-option');
    var sourceValue = button.getAttribute('data-option-value');
    var names = optionNames();
    var currentValues = names.map(nativeValue);
    var sourceIndex = names.indexOf(sourceName);
    if (sourceIndex >= 0) currentValues[sourceIndex] = sourceValue;

    var userInitiated = event.isTrusted === true;
    setTimeout(function() {
      loadProductData().then(function() {
        var target = compatibleVariant(sourceName, sourceValue, currentValues);
        if (target) syncVariant(target.names, target.variant, sourceName, currentValues, userInitiated);
      }).catch(function(error) {
        console.warn('AW variant synchronization:', error);
      });
    }, 80);

    setTimeout(function() {
      syncProductWizGalleryColor(nativeValue('Color') || (sourceName === 'Color' ? sourceValue : ''));
    }, 420);
  }, true);
})();

/* Keep wheel pricing explicit and independent from the quantity selector:
 * show the selected variant's price for one wheel and for four wheels. */
(function() {
  if (window.__awWheelPricePair || !/^\/products\//.test(location.pathname)) return;
  window.__awWheelPricePair = true;

  var updateScheduled = false;

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency
    }).format(Number(cents || 0) / 100);
  }

  function selectedVariantPrice() {
    var idInput = document.querySelector('form[data-product-form] [name="id"]');
    var id = idInput && String(idInput.value);
    if (!id) return null;

    var product = window.__productWizRioProduct;
    if (product && Array.isArray(product.variants)) {
      var variant = product.variants.find(function(item) { return String(item.id) === id; });
      if (variant && Number.isFinite(Number(variant.price))) return Number(variant.price);
    }

    var data = window.variantDataMap && window.variantDataMap[id];
    return data && Number.isFinite(Number(data.price)) ? Number(data.price) : null;
  }

  function updateWheelPricePair() {
    updateScheduled = false;
    var pair = document.querySelector('.product__price [data-wheel-price-pair]');
    var price = pair && selectedVariantPrice();
    if (!pair || price === null) return;

    var each = pair.querySelector('[data-price]');
    var four = pair.querySelector('[data-wheel-set-price]');
    var eachText = formatMoney(price);
    var fourText = formatMoney(price * 4);
    if (each && each.textContent.trim() !== eachText) each.textContent = eachText;
    if (four && four.textContent.trim() !== fourText) four.textContent = fourText;
  }

  function scheduleWheelPricePair() {
    if (updateScheduled) return;
    updateScheduled = true;
    requestAnimationFrame(updateWheelPricePair);
  }

  function installWheelPricePair() {
    scheduleWheelPricePair();
    var pricing = document.querySelector('[data-product-pricing]');
    if (pricing) {
      new MutationObserver(scheduleWheelPricePair).observe(pricing, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
    var form = document.querySelector('form[data-product-form]');
    if (form) form.addEventListener('change', scheduleWheelPricePair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installWheelPricePair, { once: true });
  } else {
    installWheelPricePair();
  }
})();

(function() {
  if (window.__awGlobalSizeInfo) return;
  window.__awGlobalSizeInfo = true;

  var enabledHandles = {
    'aw01-for-rivian-r1t-r1s': true,
    'aw08-for-rivian-r1t-r1s': true,
    'aw09-wheels': true,
    'aw10-for-rivian-r1t-r1s': true,
    'aw13-wheels': true,
    'awd-for-rivian-r1t-r1s': true,
    'awdf-for-rivian-r1t-r1s': true,
    'awdx-for-rivian-r1t-r1s': true,
    'awr1-for-rivian-r1t-r1s': true,
    'awx-for-rivian-r1t-r1s': true,
    'awx1-rivian-r1t-r1s': true,
    'awz2-for-rivian-r1t-r1s': true,
    'awzz-for-rivian-r1t-r1s': true,
    'aw09-rivian-r2': true,
    'aw10-rivian-r2': true,
    'awdx-rivian-r2': true,
    'awsr-rivian-r2': true
  };
  var handleMatch = location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = handleMatch && handleMatch[1];
  if (!enabledHandles[handle]) return;

  var productData = window.__productWizRioProduct || null;
  if (!productData && handle) {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(data) { productData = data; })
      .catch(function() {});
  }

  function addStyle() {
    if (document.getElementById('aw-global-size-info-style')) return;
    var style = document.createElement('style');
    style.id = 'aw-global-size-info-style';
    style.textContent = 'button.aw-info-btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:16px!important;height:16px!important;min-width:16px!important;min-height:16px!important;border-radius:50%!important;border:1.5px solid #999!important;background:transparent!important;color:#555!important;font:italic 700 11px/1 Georgia,serif!important;margin:0 0 2px 8px!important;padding:0!important;cursor:pointer!important;vertical-align:middle!important;opacity:.65!important}button.aw-info-btn:hover{opacity:1!important;color:#111!important;border-color:#111!important}.aw-info-modal{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:24px}.aw-info-modal[aria-hidden="false"]{display:flex}.aw-info-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.58)}.aw-info-modal__panel{position:relative;width:min(560px,calc(100vw - 32px));max-height:calc(100vh - 48px);overflow:auto;background:#fff;color:#111;border-radius:8px;padding:28px;box-shadow:0 18px 60px rgba(0,0,0,.35)}.aw-info-modal__close{position:absolute;top:10px;right:12px;border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer;color:#666}.aw-info-modal__title{margin:0 36px 16px 0;font-size:22px;line-height:1.2}.aw-info-modal__body{font-size:16px;line-height:1.5}.aw-info-modal__body p{margin:0 0 10px}.aw-info-modal__body code{background:#f4f4f4;border-radius:4px;padding:2px 5px}';
    document.head.appendChild(style);
  }

  function ensureModal() {
    var modal = document.getElementById('aw-info-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'aw-info-modal';
    modal.className = 'aw-info-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = '<div class="aw-info-modal__backdrop" data-aw-close></div><div class="aw-info-modal__panel" role="document"><button type="button" class="aw-info-modal__close" data-aw-close aria-label="Close">&times;</button><h3 class="aw-info-modal__title" data-aw-title></h3><div class="aw-info-modal__body" data-aw-body></div></div>';
    document.body.appendChild(modal);
    return modal;
  }

  function cleanLabel(text) {
    return String(text || '').trim().replace(/\s*i\s*$/i, '').replace(/:$/, '').toLowerCase();
  }

  function hasButton(el) {
    if (el.querySelector && el.querySelector('.aw-info-btn-js')) return true;
    return el.nextElementSibling && el.nextElementSibling.classList && el.nextElementSibling.classList.contains('aw-info-btn-js');
  }

  function addButton(el) {
    if (hasButton(el)) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aw-info-btn aw-info-btn-js aw-global-size-info-btn';
    btn.setAttribute('data-aw-info', 'size');
    btn.setAttribute('aria-label', 'What is Size and weight?');
    btn.textContent = 'i';
    if (el.tagName === 'STRONG') el.insertAdjacentElement('afterend', btn);
    else el.appendChild(btn);
  }

  function ensureIcons() {
    addStyle();
    var labels = document.querySelectorAll('.product-description__specification td, .product-description strong, .rte strong');
    var found = false;
    labels.forEach(function(label) {
      if (cleanLabel(label.textContent) !== 'size and weight') return;
      addButton(label);
      found = true;
    });
    return found;
  }

  function currentVariantId() {
    var urlMatch = location.search.match(/[?&]variant=(\d+)/);
    if (urlMatch) return urlMatch[1];
    var picker = document.querySelector('variant-selection[variant]');
    var pickerVariant = picker && picker.getAttribute('variant');
    if (pickerVariant) return pickerVariant;
    var input = document.querySelector('form[data-product-form] [name="id"]');
    return input && input.value;
  }

  function selectedVariant() {
    if (!productData || !productData.variants) return null;
    var id = currentVariantId();
    if (id) {
      for (var i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === String(id)) return productData.variants[i];
      }
    }
    return productData.variants[0] || null;
  }

  function optionIndex(name) {
    if (!productData || !productData.options) return -1;
    for (var i = 0; i < productData.options.length; i++) {
      var optionName = typeof productData.options[i] === 'string' ? productData.options[i] : productData.options[i].name;
      if (String(optionName || '').toLowerCase() === name.toLowerCase()) return i;
    }
    return -1;
  }

  function visibleSizeText() {
    var rows = document.querySelectorAll('.product-description__specification tr');
    for (var i = 0; i < rows.length; i++) {
      var cells = rows[i].querySelectorAll('td');
      if (cells.length < 2 || cleanLabel(cells[0].textContent) !== 'size and weight') continue;
      if (!rows[i].getClientRects().length) continue;
      return cells[1].textContent.trim();
    }

    var labels = document.querySelectorAll('.product-description strong, .rte strong');
    for (var j = 0; j < labels.length; j++) {
      if (cleanLabel(labels[j].textContent) !== 'size and weight') continue;
      var parent = labels[j].parentElement;
      if (!parent || !parent.getClientRects().length) continue;
      return parent.textContent.replace(labels[j].textContent, '').trim();
    }

    var variant = selectedVariant();
    if (!variant || !variant.options) return '';
    var diameter = variant.options[optionIndex('Diameter')] || '';
    var size = variant.options[optionIndex('Size')] || '';
    var diameterNumber = String(diameter).replace(/[^\d.]/g, '');
    return diameterNumber && size ? diameterNumber + 'x' + size : [diameter, size].filter(Boolean).join(' ');
  }

  function parseSpec(text) {
    var normalized = String(text || '').replace(/×/g, 'x');
    var size = normalized.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    var offset = normalized.match(/([+-])\s*(\d+(?:\.\d+)?)/);
    var weight = normalized.match(/~\s*([\d.]+)\s*lbs/i);
    return {
      raw: normalized.trim(),
      diameter: size && size[1],
      width: size && size[2],
      offset: offset && (offset[1] + offset[2]),
      weight: weight && weight[1]
    };
  }

  function article(value) {
    return String(value).match(/^8(?:\.|$)/) ? 'an' : 'a';
  }

  function openModal() {
    addStyle();
    var modal = ensureModal();
    var title = modal.querySelector('[data-aw-title]');
    var body = modal.querySelector('[data-aw-body]');
    var spec = parseSpec(visibleSizeText());
    title.textContent = 'Wheel Size and Weight';
    var html = '<p>The <strong>Size and weight</strong> row shows the wheel <strong>diameter</strong>, <strong>width</strong>, <strong>offset</strong>, and approximate wheel weight.</p>';
    if (spec.diameter && spec.width) {
      html += '<p><code>' + spec.raw + '</code> means ' + article(spec.diameter) + ' ' + spec.diameter + '-inch diameter, ' + article(spec.width) + ' ' + spec.width + '-inch-wide wheel';
      if (spec.offset) html += ' with a ' + spec.offset + '&nbsp;mm offset';
      html += '.</p>';
    } else {
      html += '<p>Wheel specs are usually written as diameter x width plus offset. For example, <code>20x9.0&quot; +40</code> means a 20-inch diameter, 9.0-inch-wide wheel with a +40&nbsp;mm offset.</p>';
    }
    if (spec.weight) html += '<p><strong>' + spec.weight + ' lbs</strong> is the approximate weight of one wheel; small manufacturing tolerance is normal.</p>';
    html += '<p>Offset is the distance from the wheel centerline to the mounting face. It controls how far the wheel sits in or out of the fender.</p>';
    body.innerHTML = html;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = document.getElementById('aw-info-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(event) {
    var close = event.target.closest && event.target.closest('[data-aw-close]');
    if (close) {
      event.preventDefault();
      closeModal();
      return;
    }
    var btn = event.target.closest && event.target.closest('[data-aw-info="size"], .aw-global-size-info-btn');
    if (!btn) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openModal();
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeModal();
  });

  function start() {
    ensureIcons();
    var scheduled = false;
    var observer = new MutationObserver(function() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function() {
        scheduled = false;
        ensureIcons();
      }, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(ensureIcons, 500);
    setTimeout(ensureIcons, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ──────────────────────────────────────────────────────────────────────────
 * Klaviyo scroll-lock safety net.
 *
 * Klaviyo's signup popup adds `klaviyo-prevent-body-scrolling` to <body>
 * (overflow:hidden). It is supposed to be removed when the popup closes,
 * but sometimes lingers — leaving the entire page frozen and breaking the
 * sticky product-nav bar. Watch <body> + the DOM and strip the class
 * whenever no Klaviyo modal is actually visible.
 * ────────────────────────────────────────────────────────────────────────── */
(function () {
  if (typeof MutationObserver === 'undefined') return;
  function klaviyoModalVisible() {
    return !!document.querySelector(
      '.klaviyo-form-version-cid_1[style*="display: block"], ' +
      '.needsclick[id^="klaviyo"][style*="display: block"], ' +
      '[data-testid="klaviyo-form"][style*="display: block"]'
    );
  }
  function unstickIfStale() {
    if (document.body.classList.contains('klaviyo-prevent-body-scrolling') && !klaviyoModalVisible()) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }
  }
  new MutationObserver(unstickIfStale).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
})();
